import $ from 'jquery';

$('.js-form-lead').on('submit', function(e) {
    e.preventDefault();

    const $form = $(this);

    const $submitBtn = $form.find('.js-btn');
    const phone = $form.find('input[name="phone"]').val();
    const name = $form.find('input[name="name"]').val();
    const event_label = $form.find('input[name="event_label"]').val();
    const payload = JSON.stringify({
        phone,
        name
    });

    $submitBtn.attr('disabled', true);

    dataLayer.push({
        event_name: "generate_lead",
        event_label: event_label,
        event: "fireEvent"
    });

    fetch(ajax_object.ajax_url, {
        method: "POST",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `action=app_post_new_lead&data=${payload}`
    })
        .then(response => response.json())
        .then(data => {
            const apiResponse = JSON.parse(data.data);
            if( apiResponse?.response?.status){
                $('.js-response-message').html('הטופס הוגש בהצלחה. ניצור עמך קשר בהקדם.');
            }else{
                $('.js-response-message').html('תקלה התרחשה. אנא נסה שוב.');
            }
		})
        .finally(() => {
            $submitBtn.attr('disabled', false);
        })
})